import { useNavigate } from 'react-router';

import lang from '../../../lib/language';

import heroImage from '../../../assets/bigImages/referrals-locked-hero.png';
import config from '../../../config';
import { UI_ROUTES } from '../../../util/routes';

import styles from './ReferralsLockedBanner.module.scss';

const ReferralsLockedBanner = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.title}>{lang.referralsLockedTitle()}</div>
        <div className={styles.description}>{lang.referralsLockedDescription()}</div>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={() => navigate(UI_ROUTES.products)}
          >
            {lang.referralsLockedStartChallenge()}
          </button>
          <a
            className={styles.secondaryButton}
            href={config.links.referralsLearnMoreUrl}
            target="_blank"
            rel="noreferrer"
          >
            {lang.referralsLockedLearnMore()}
          </a>
        </div>
      </div>

      <img className={styles.hero} src={heroImage} alt="" />
    </div>
  );
};

export default ReferralsLockedBanner;
